/**
 * GoldenWings Resources Hub Page
 * Navigation to different resource types
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, Row, Col, Typography } from 'antd';
import {
  SendOutlined,
  EnvironmentOutlined,
  SolutionOutlined,
  TeamOutlined,
} from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

const { Title, Paragraph } = Typography;

interface ResourceCardProps {
  title: string;
  description: string;
  icon: React.ReactNode;
  onClick: () => void;
}

const ResourceCard: React.FC<ResourceCardProps> = ({
  title,
  description,
  icon,
  onClick,
}) => {
  return (
    <Card
      hoverable
      onClick={onClick}
      style={{ height: '100%', textAlign: 'center' }}
    >
      <div style={{ marginBottom: 16 }}>{icon}</div>
      <Title level={4}>{title}</Title>
      <Paragraph type="secondary">{description}</Paragraph>
    </Card>
  );
};

export const ResourcesPage: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const resources = [
    {
      title: t('goldenwings.airplanes'),
      description: t('goldenwings.airplanes_description'),
      icon: <SendOutlined style={{ fontSize: 48, color: '#52c41a' }} />,
      path: '/apps/goldenwings/resources/airplanes',
    },
    {
      title: t('goldenwings.airports'),
      description: t('goldenwings.airports_description'),
      icon: <EnvironmentOutlined style={{ fontSize: 48, color: '#faad14' }} />,
      path: '/apps/goldenwings/resources/airports',
    },
    {
      title: t('goldenwings.instructors'),
      description: t('goldenwings.instructors_description'),
      icon: <SolutionOutlined style={{ fontSize: 48, color: '#722ed1' }} />,
      path: '/apps/goldenwings/resources/instructors',
    },
    {
      title: t('goldenwings.students'),
      description: t('goldenwings.students_description'),
      icon: <TeamOutlined style={{ fontSize: 48, color: '#eb2f96' }} />,
      path: '/apps/goldenwings/resources/students',
    },
  ];

  return (
    <div style={{ padding: 24 }}>
      <div style={{ marginBottom: 32, textAlign: 'center' }}>
        <Title level={2}>{t('goldenwings.resources')}</Title>
        <Paragraph>{t('goldenwings.resources_description')}</Paragraph>
      </div>

      <Row gutter={[24, 24]}>
        {resources.map((resource) => (
          <Col xs={24} sm={12} lg={6} key={resource.path}>
            <ResourceCard
              title={resource.title}
              description={resource.description}
              icon={resource.icon}
              onClick={() => navigate(resource.path)}
            />
          </Col>
        ))}
      </Row>
    </div>
  );
};
